import { createApp } from 'vue';
import App from './App.vue'; 
import router from './router';
import moment from 'moment';
import '@fortawesome/fontawesome-free/js/all.js';
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Checkbox from 'primevue/checkbox';
import Row from 'primevue/row';
import Calendar from 'primevue/calendar'
import "./sass/app.scss";

import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';


// Base Components and Pages
import TheHeader from './components/Layout/TheHeader.vue';
import TheFooter from './components/Layout/TheFooter.vue';
import BasePage from './components/Base/BasePage.vue';
import BaseToast from './components/Base/BaseToast.vue';
import BaseButton from './components/Base/BaseButton.vue';
import BaseInput from './components/Base/BaseInput.vue';
import BaseSwitch from './components/Base/BaseSwitch.vue';
import BaseSelect from './components/Base/BaseSelect.vue';
import BaseLabel from './components/Base/BaseLabel.vue';
import BasePopup from './components/Base/BasePopup.vue';
import BaseTextarea from './components/Base/BaseTextarea.vue';
import BaseCheckbox from './components/Base/BaseCheckbox.vue';
import BaseFileLoader from './components/Base/BaseFileLoader.vue';
import BaseDataTable from './components/Base/BaseDataTable.vue';
import BaseSpinner from './components/Base/BaseSpinner.vue';
import BaseCalendar from './components/Base/BaseCalendar.vue';
import BaseModal from './components/Base/BaseModal.vue';
import BaseNumber from './components/Base/BaseNumber.vue';
import BasePhone from './components/Base/BasePhone.vue';
import BaseEmail from './components/Base/BaseEmail.vue';
import BaseRangeDatePicker from './components/Base/BaseRangeDatePicker.vue';
import BaseOtpInput from './components/Base/BaseOtpInput.vue';
import BaseRadio from './components/Base/BaseRadio.vue';
// In your main.js or App.vue
import 'font-awesome/css/font-awesome.css';
import "@fortawesome/fontawesome-free/css/all.css";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import store from './Views/Pages/RentalPayments/store.js'



// Create Vue application
const app = createApp(App);
app.config.compilerOptions.isCustomElement = (tag) => {
    return tag.startsWith('llp-');
};
// Use PrimeVue and Router
app.use(PrimeVue); 
app.use(router);
app.use(ToastService);
app.use(store);
app.component('ToastPrime', Toast);

// Global properties
const env = process.env.MIX_LH_ENV;
app.config.globalProperties.env = env;
app.config.globalProperties.moment = moment;
// Base Components Registration
app.component('llp-header', TheHeader);
app.component('llp-footer', TheFooter);

app.component('llp-page', BasePage);
app.component('llp-toast', BaseToast);
app.component('llp-button', BaseButton);
app.component('llp-input', BaseInput);
app.component('llp-file-loader', BaseFileLoader);
app.component('llp-switch', BaseSwitch);
app.component('llp-select', BaseSelect);
app.component('llp-label', BaseLabel);
app.component('llp-popup', BasePopup);
app.component('llp-textarea', BaseTextarea);
app.component('llp-checkbox', BaseCheckbox);
app.component('llp-datatable', BaseDataTable);
app.component('llp-spinner', BaseSpinner);
app.component('llp-calendar', BaseCalendar);
app.component('llp-modal', BaseModal);
app.component('llp-number', BaseNumber);
app.component('llp-phone', BasePhone);
app.component('llp-email', BaseEmail);
app.component('llp-daterange',BaseRangeDatePicker);
app.component('llp-otp-input',BaseOtpInput);
app.component('llp-radio',BaseRadio);



// Third party components 
app.component('DataTable', DataTable);
app.component('ColumnPrime', Column);
app.component('CheckboxPrime', Checkbox);
app.component('ColumnGroup', ColumnGroup);
app.component('RowPrime', Row);
app.component('CalendarPrime', Calendar);

// Mount the application to the DOM
app.mount('#llp');
